const entries = [];

export function logRequest(event) {
  entries.push({
    ...event,
    at: event.at ?? Date.now()
  });
  if (entries.length > 200) {
    entries.shift();
  }
}

export function getRequestLog() {
  return [...entries];
}

export function clearRequestLog() {
  entries.length = 0;
}

export function getLastCorrelationId() {
  for (let i = entries.length - 1; i >= 0; i -= 1) {
    if (entries[i].correlationId) {
      return entries[i].correlationId;
    }
  }
  return null;
}
